import { useNavigate } from "react-router-dom"
import { useMobileDetection } from "../hook/useMobileDetection"
import {useTranslation} from 'react-i18next'

export const MensajeMayorEdad = () => {
    
    const animationLogos = {
        left:"/image/logos/LogoAnimation/logoML.png",
        center:"/image/logos/LogoAnimation/logoMC.png",
        right:"/image/logos/LogoAnimation/logoMR.png"
    }

    const { t } = useTranslation()
    const isMobile = useMobileDetection()

    const navigate = useNavigate()

    const inicioApp = () => {
        navigate('/inicio')
    }

    const salir = () => {
        window.location.href = 'https://es.wikipedia.org/wiki/Pisco_del_Per%C3%BA'
    }

    return (
        <div className="bg-primario vh-100 d-flex justify-content-center position-relative" style={{overflow:"hidden"}}>
            
                
            <img  src={animationLogos.center} alt="" className="mountains mdelay2"></img>
            <img src={animationLogos.right} alt="" className="mountains mdelay1"></img>
            <img src={animationLogos.left} alt="" className="mountains mdelay0"></img>
                
            <div className={`bg-secundario ${isMobile ? "p-3" : "p-5"} m-auto mx-3  rounded-2 position-relative`} style={{zIndex:1}}>                    
                <h1 className="text-center">{t('edad_pregunta') }</h1>
                <div className="mt-5 mb-2">
                    <button type="button" className="btn btn-primario w-100 text-white mx-auto m-1" onClick={inicioApp}><strong>{t("edad_resp_positiva")}</strong></button>
                    <button type="button" className="btn btn-primario w-100 text-white mx-auto m-1" onClick={salir}><strong>{t("edad_resp_negativa")}</strong></button>
                </div>
                <div className="mt-3">
                    <div className="text-center" style={{ color: "rgb(128,128,128)" }}>{t("edad_msg_restriccion")}</div>                        
                </div>
            </div>
            <div className="w-100 mb-2" style={{position:"absolute",bottom:"0"}}>
                <div className="text-center px-3 fw-bold" style={{fontSize:"calc(.75rem + 1.25vw)", color:"var(--color-cuaternario-hover)"}}>{t("edad_msg_advertencia")}</div>
            </div>
        </div>
    )
}
